import * as React from "react";
import { Link } from "react-router-dom";

import "./StandardLink.scss";

const classNameVariant = {
  main: "text-main",
  primary: "text-primary",
  secondary: "text-secondary",
  success: "text-success",
  danger: "text-danger",
  warning: "text-warning",
  info: "text-info",
  light: "text-light",
  dark: "text-dark",
};

const classNameSize = {
  lg: "large-link",
  md: "default-link",
  sm: "small-link",
};

const StandardLink = (props) => {
  const { children, className, size = "md", variant = "main", ...rest } = props;

  return (
    <Link
      className={`standard-link-component ${className ? className : ""} ${
        classNameVariant[variant]
      } ${classNameSize[size] || ""}`}
      {...rest}
    >
      {children}
    </Link>
  );
};

export default StandardLink;
